<div class="flex-layout">
  <mat-nav-list   [ngClass]="{
    'sidebar-list': true,
    'onlyIcon': onlyIcon
  }">
    <app-nav-item *ngFor="let item of navItems" [item]="item" [onlyIcon]="onlyIcon"> </app-nav-item>
  </mat-nav-list>

</div>


